'use client';

import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Dialog as MuiDialog,
  type SxProps,
  styled,
} from '@mui/material';
import type { ReactNode } from 'react';

import { campaignManagerTheme } from '@campaign-manager/theme';

const RmtDialog = styled(MuiDialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: '12px',
  },
}));

interface Props {
  title?: ReactNode | string;
  description?: ReactNode;
  actions?: ReactNode;
  open?: boolean;
  onClose?: () => void;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';

  children: ReactNode;
  sx?: SxProps;
}

export default function Dialog({
  title,
  description,
  actions,
  open = false,
  onClose,
  children,
  size = 'xs',
  sx,
}: Props) {
  return (
    <RmtDialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={size}
      slotProps={{ paper: { elevation: 6 } }}
      sx={sx}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent sx={{ pb: 3 }}>
        {description && (
          <DialogContentText
            variant="body1"
            sx={{ color: campaignManagerTheme.color.darkGrey }}
          >
            {description}
          </DialogContentText>
        )}
        {children}
      </DialogContent>
      {actions && <DialogActions sx={{ pt: 0, pb: 3, px: 3 }}>{actions}</DialogActions>}
    </RmtDialog>
  );
}
